export default "__VITE_ASSET__f0e72ef4__"